import { combineReducers } from "redux";
import theme from "./theme";
import userInteraction from "./userInteraction";
import siteData from "./siteData";
import userAccess from "./userAccess";
import taskList from "./taskList";
import language from "./language";

export default combineReducers({
  theme,
  userInteraction,
  siteData,
  userAccess,
  taskList,
  language
});
